<template>
  <div class="app has-header">
    <div class="header main">
      <div class="align-left">
        <!--<dateselectionheader :label="monthDisplay" @PrevDate="PreviousDate" @NextDate="NextDate"
                             @CalendarOpen="toggleDatePicker" @SetToday="SetDateToCurrentDay"/>-->
      </div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons"/>
      </div>
      <div class="align-right">
        <headerbuttonstack :state="sideButtons"/>
      </div>
    </div>


    <div class="tablecontainer scrollbar-container">
      <div v-if="!loading">
        <datatablesimple :state="dataTableSimpleState"></datatablesimple>
      </div>
    </div>
    <div v-if="loading" class="loading-md bg">
      <i class="fas fa-spinner"></i>
      <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
        {{ loadingText }}
      </div>
    </div>

  </div>
</template>

<script>
import datatablesimple from '../../uicomponents/datatablesimple.vue';
import VueEventBus from '../../../vue-event-bus';
import {mapState, mapGetters} from 'vuex';

export default {
  name: 'skillsoverview',
  components: {
    datatablesimple
  },
  data() {
    return {
      loadingText: this.$t('global.ui.loadX', [this.$t('pages.employeeContext.skills')]),
      employeeMap: {},
      sortByName: true,
      alwaysUnfold: false,
      hideInactive: true,
      skillsDropdownOptions: [],

      loading: false
    }
  },
  created: function () {
    this.$helpers.GetStoreSettings();
    this.refresh(true);
  },
  computed: {
    ...mapGetters(['storeId', 'anonMode', 'storeSettings', 'rosterFromTo', 'skillMap', 'employeeSkillMap', 'spotMap', 'permissions', 'isSuperUser']),
    canEditValues() {
      let val = false;
      Object.values(this.permissions).forEach(perms => {
        let perm = perms.find(p => p.id == 11);
        if (perm && perm.level > 2) { //permission to edit balance fields
          val = true;
        }
      });
      return val;
    },
    employeeEmployeeSkillMap(){
      let map = {};
      Object.values(this.employeeSkillMap).forEach(es => {
        if(!map[es.employeeId]){
          map[es.employeeId] = [];
        }
        map[es.employeeId].push(es);
      });
      Object.values(this.employeeMap).forEach(e => {
        if(!map[e.id] || map[e.id].length < 1){
          map[e.id] = [];
          map[e.id].push({id: 'temp' + e.id, employeeId: e.id, value: 0, skillId: -2})
        }
        
      });
     
      return map;
    },
    skillSpotMap(){
      let map = {};
      Object.values(this.skillMap).forEach(s => {
        let spot = Object.values(this.spotMap).find(spot => spot.requiredSkill == s.id);
        map[s.id] = spot ? spot.id : null;
      })
      
      return map;
    },
    headerButtons() {
      let view = this;
      let state = {
        buttons: [

          {
            type: "block",
            icon: "fa-sync-alt",
            click: () => {
              view.refresh(true)
            },
            tooltip: this.$t('global.general.refreshData')
          },
        ],
        showListIconAlways: true
      };
      state.helperLinks = [
        {
          title: this.$t('pages.comp.skillsOverview'),
          helperText: this.$t('pages.comp.skillsOverviewHelp'),
          externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2524905473",
          externalLabel: this.$t('global.ui.wouldYouLikeToKnowMore'),
          cancelLabel: this.$t('pages.comp.thanks'),
        },
        {
          title:  this.$t('store.structure.getSupport'),
          helperText:  this.$t('store.structure.getSupportHelp'),
          externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15",
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close')
        }
      ];
      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [
          {
            type: "block border-r",
            icon: "fa-eye",
            tooltip: this.$t('global.ui.viewOptions'),
            click: ($event) => {
              view.OpenMenuDetails($event, this.viewFilterMenuState);
            },

          },
          {
            type: "block",
            icon: "fa-print",
            tooltip: this.$t('global.ui.reportsExports'),
            click: ($event) => {
              view.OpenMenuDetails($event, this.reportMenuState);
            }
          }
        ]
      };


      return state;
    },
    reportMenuState() {
      let view = this;
      let state = {
        componentref: 'burgermenustate',
        groups: [],
        items: []
      };

      let exportGroup = {
        label: this.$t('global.ui.csvExport'),
        items: [
          {
            closeOnClick: true,
            classes: "export-csv",
            type: "block cyan",
            disabled: false,
            icon: "fa-file-csv",
            click: () => {
              view.exportCsv();
            },
            show: true,
            tooltip: this.$t('global.ui.exportCsv'),
            text: this.$t('global.ui.exportCsv'),
            helperText: this.$t('pages.comp.skillsCsvHelp')
          }
        ]
      }

      state.groups.push(exportGroup);

      return state;
    },
    viewFilterMenuState() {
      let view = this;
      let state = {
        componentref: 'burgermenustate',
        groups: [],
        items: []
      };

      let group0 = {
        label: this.$t('global.ui.viewOptions'),
        items: [
          {
            closeOnClick: true,
            icon: this.sortByName ? "fa-sort-numeric-down" : "fa-sort-alpha-down",
            text: this.sortByName ? this.$t('global.ui.sortByPersonalNumber') : this.$t('global.ui.sortByName'),
            disabled: false,
            show: true,
            click: () => {
              view.sortByName = !view.sortByName;
            }
          },
          {
            closeOnClick: true,
            icon: this.hideInactive ? "fa-eye" : "fa-eye-slash",
            text: this.hideInactive ? this.$t('pages.comp.showInactiveEmployees') : this.$t('pages.comp.hideInactiveEmployees'),
            disabled: false,
            show: true,
            click: () => {
              view.hideInactive = !view.hideInactive;
            }
          },
           {
            closeOnClick: true,
            icon: !this.alwaysUnfold ? "fa-eye" : "fa-eye-slash",
            text: !this.alwaysUnfold ? this.$t('pages.comp.expandAll') : this.$t('pages.comp.collapseAll'),
            disabled: false,
            show: true,
            click: () => {
              view.alwaysUnfold = !view.alwaysUnfold;
            }
          },
          {
            classes: "spot-filter",
            type: "block",
            disabled: false,
            icon: view.skillsDropdownOptions.find((i) => i.id == -1).toggled ? "fa-filter" : "fa-filter",
            click: ($event) => {
              view.OpenSkillsDropdown($event);
            },
            show: true,
            text: this.$t('pages.comp.filterSkills'),
          }
        ]
      };

      // Alternativskills
      let skillsGroup = {
        label: this.$t('pages.comp.skillsFilter'),
        items: []
      }

      skillsGroup.items.push({
        classes: "spot-all",
        type: "block",
        disabled: false,
        icon: view.skillsDropdownOptions.find((i) => i.id == -1).toggled ? "fa-check-circle" : "fa-circle",
        click: () => {
          view.skillsDropdownOptions.forEach(option => {
            option.toggled = !view.skillsDropdownOptions.find((i) => i.id == -1).toggled;
          })
          view.skillsDropdownOptions = view.skillsDropdownOptions.slice();
        },
        show: true,
        closeOnClick: true,
        text: this.$t('pages.comp.allSkills'),
      });

      Object.values(this.skillMap).forEach(function (skill) {
        let item = {
          classes: "spot-item",
          type: "block",
          disabled: false,
          icon: view.skillsDropdownOptions.find((i) => i.id == skill.id).toggled ? "fa-check-circle" : "fa-circle",
          click: () => {
            view.skillsDropdownOptions.forEach((option) => {
              if (option.id == skill.id) {
                option.toggled = !option.toggled;
              }
            });
            view.skillsDropdownOptions = view.skillsDropdownOptions.slice();
          },
          show: true,
          closeOnClick: true,
          text: skill.name,
        };
        skillsGroup.items.push(item);
      });

      skillsGroup.items.push({
        classes: "spot-unassigned",
        type: "block",
        disabled: false,
        icon: view.skillsDropdownOptions.find((i) => i.id == -2).toggled ? "fa-check-circle" : "fa-circle",
        click: () => {
          view.skillsDropdownOptions.forEach((option) => {
            if (option.id == null) {
              option.toggled = !option.toggled;
            }
          });
          view.skillsDropdownOptions = view.skillsDropdownOptions.slice();
        },
        show: true,
        closeOnClick: true,
        tooltip: this.$t('global.ui.unassigned'),
        text: this.$t('global.ui.unassigned'),
      });

      state.groups.push(group0);
      //state.groups.push(spotGroup);

      return state;
    },
    dataTableSimpleState() {
      let view = this;

      let secondSkills = view.skillsDropdownOptions.filter(item => item.toggled).map(item => item.id);
      

      let data = Object.values(view.employeeMap)
          .filter(emp => view.hideInactive ? emp.active : true)
          .filter(emp => secondSkills.some(ss =>
              this.employeeEmployeeSkillMap[emp.id].some(s => ss === s.skillId)
          ))
          .map((e) => {
            return Object.assign({}, e)
          });

      data.forEach(d => {
        var mainSkill = '';
        var mainSkillValue = 0;
        var mainSkillId = null;
        
        let filteredEmployeeSkills = this.employeeEmployeeSkillMap[d.id].filter(es => secondSkills.includes(es.skillId));
        let spotSkill = null;
        //first check if we can find spot Skill
        if(d.spotId){
          spotSkill = filteredEmployeeSkills.find(es => this.skillSpotMap[es.skillId] == d.spotId)
        }
        if(spotSkill){
          mainSkill = this.skillMap[spotSkill.skillId].name+" (P)";
          mainSkillValue = spotSkill.value;
          mainSkillId = spotSkill.id;
        } else {
          //find the highest skill
          filteredEmployeeSkills.forEach(es => {
            if(mainSkillId == null || es.value > mainSkillValue){
              mainSkill = this.skillMap[es.skillId] ? this.skillMap[es.skillId].name : this.$t('pages.comp.noSkill');
              mainSkillValue = es.value;
              mainSkillId = es.id;
            }
          });
        }
        d.mainSkill = mainSkill;
        d.mainSkillValue = mainSkillValue;
        d.mainSkillId = mainSkillId;
        //determine remaining employee skills
        d.employeeSkills = [];
        filteredEmployeeSkills.forEach(es => {
            if(es.id != mainSkillId){
             
              let skill = Object.assign({}, es);
              skill.skillName = this.skillMap[es.skillId] ? this.skillMap[es.skillId].name : this.$t('pages.comp.noSkill');
              d.employeeSkills.push(skill);
            }
        });
        d.employeeSkills.sort(function (a, b) {
          if (a.value < b.value) return 1;
          if (a.value > b.value) return -1;
          if (a.value == b.value) return 0;
        });
        d.employeeSkillsMap = {};
        for (let i = 0; i < d.employeeSkills.length; i++) {
          d.employeeSkillsMap[d.employeeSkills[i].id] = d.employeeSkills[i];
        }

        if(d.employeeSkills.length > 0){
          d.subEntries = [
            {
              componentOverride: 'skillsDetails',
              componentStateBuilders: [(data) => {
                return {
                  employeeData: d,
                  employeeSkillsMap: d.employeeSkillsMap,
                  optionalColumn: !view.sortByName,
                  componentType: 'skillsDetails',
                  customEvents: {
                    Update: () => {
                    }
                  }
                }
              }]
            }
          ]
        }
      });
      data = data.filter(d => d.mainSkillId != null);
      
      data.sort(function (a, b) {
        if (view.sortByName) {
          if (a != undefined && b != undefined) {
            if (a.lastName < b.lastName) return -1;
            if (a.lastName > b.lastName) return 1;
            if (a.lastName == b.lastName && a.firstName < b.firstName) return -1;
            if (a.lastName == b.lastName && a.firstName > b.firstName) return 1;
          }
        } else {
          if (a != undefined && b != undefined) {
            let aNum = a.personnelId;
            let bNum = b.personnelId;
            if (aNum != undefined && aNum != null && bNum != undefined && aNum != bNum != null) {
              aNum = parseInt(aNum);
              bNum = parseInt(bNum);
              if (aNum < bNum) return -1;
              if (aNum > bNum) return 1;
            } else if (aNum == null || aNum == undefined) {
              return 1;
            } else {
              return -1;
            }
          }
        }

        return 0;
      });


      
      //data.push(view.positiveBalanceSummaryData);

      let state = {};

      let columns = {};
      if (!this.sortByName) {
        columns.personnelId = "PN";
      }
      columns.name = this.$tc('global.general.employee');
      columns.mainSkill = this.$tc('store.structure.skill');
      columns.mainSkillValue = this.$t('pages.comp.evaluation');
      
      
      columns.skillCount = this.$t('pages.comp.skillAmount')
      columns.actions = ' ';

      state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

      if (!this.sortByName) {
        state.headerMap.personnelId.sort = true;
        state.headerMap.personnelId.componentStateBuilders = [(data, entry) => {
          return {
            componentType: 'labelc',
            state: {text: data.personnelId ? data.personnelId : '',},
            styleLabel: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '',
              height: 'calc(100% - 10px)'
            },
          }
        }];
      }

      state.headerMap.name.stylesEntrySum = {color: 'black'}
      state.headerMap.name.sort = true;
      state.headerMap.name.DisplayLabel = (i) => i.lastName;
      state.headerMap.name.componentStateBuilders = [(data, entry) => {

        return {
          componentType: 'employeeentry',
          state: {
            firstName: data.firstName,
            lastName: data.lastName,
            employee: data,
            splitName: true,
            hideShadow: true,
            textStyle: {color: 'white', fontSize: '12px', margin: '2.5px'}
          }
        }
      }];

      state.headerMap.mainSkill.stylesEntrySum = {color: 'black'}
      state.headerMap.mainSkill.sort = false;
      state.headerMap.mainSkill.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: data.mainSkill,
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];

      state.headerMap.mainSkillValue.stylesEntrySum = {color: 'black'}
      state.headerMap.mainSkillValue.stylesEntry = {'justify-content': 'center'};
      state.headerMap.mainSkillValue.sort = false;
      state.headerMap.mainSkillValue.componentStateBuilders = [
        (data, entry) => {
          let color1 = data.mainSkillValue > 0 ? 'var(--contrast-4)' : '#898989';
          let color2 = data.mainSkillValue > 1 ? 'var(--contrast-4)' : '#898989';
          let background = 'linear-gradient(90deg, ' + color1 + ' 50%, ' + color2 + ' 50%)';

          return {
            componentType: 'buttonc',
            tooltip: "",
            type: 'button icon-overlay square',
            icon: 'fa-star',
            disabled: false,
            styleButton: {margin: '0px', padding: '0px' },
            styleIcon: {
              backgroundImage: background,
              backgroundClip: 'text',
              '-webkit-background-clip': 'text',
              color: 'transparent'
            },
            customEvents: {
              click: (event) => {
                let employeeSkill = {
                  id: data.mainSkillId,
                  employeeId: data.id
                }
                if (event.offsetX < 10) {
                  employeeSkill.value = 1;
                } else {
                  employeeSkill.value = 2;
                }
                view.EditEmployeeSkillBackendCall(employeeSkill);
              }
            }
          }
        },
        (data, entry) => {
          let color1 = data.mainSkillValue > 2 ? 'var(--contrast-4)' : '#898989';
          let color2 = data.mainSkillValue > 3 ? 'var(--contrast-4)' : '#898989';
          let background = 'linear-gradient(90deg, ' + color1 + ' 50%, ' + color2 + ' 50%)';

          return {
            componentType: 'buttonc',
            tooltip: "",
            type: 'button icon-overlay square',
            icon: 'fa-star',
            disabled: false,
            styleButton: {margin: '0px', padding: '0px'},
            styleIcon: {
              backgroundImage: background,
              backgroundClip: 'text',
              '-webkit-background-clip': 'text',
              color: 'transparent'
            },
            customEvents: {
              click: (event) => {
                let employeeSkill = {
                  id: data.mainSkillId,
                  employeeId: data.id
                }
                if (event.offsetX < 10) {
                  employeeSkill.value = 3;
                } else {
                  employeeSkill.value = 4;
                }
                view.EditEmployeeSkillBackendCall(employeeSkill);
              }
            }
          }
        },
        (data, entry) => {
          let color1 = data.mainSkillValue > 4 ? 'var(--contrast-4)' : '#898989';
          let color2 = data.mainSkillValue > 5 ? 'var(--contrast-4)' : '#898989';
          let background = 'linear-gradient(90deg, ' + color1 + ' 50%, ' + color2 + ' 50%)';

          return {
            componentType: 'buttonc',
            tooltip: "",
            type: 'button icon-overlay square',
            icon: 'fa-star',
            disabled: false,
            styleButton: {margin: '0px', padding: '0px'},
            styleIcon: {
              backgroundImage: background,
              backgroundClip: 'text',
              '-webkit-background-clip': 'text',
              color: 'transparent'
            },
            customEvents: {
              click: (event) => {
                let employeeSkill = {
                  id: data.mainSkillId,
                  employeeId: data.id
                }
                if (event.offsetX < 10) {
                  employeeSkill.value = 5;
                } else {
                  employeeSkill.value = 6;
                }
                view.EditEmployeeSkillBackendCall(employeeSkill);
              }
            }
          }
        },
        (data, entry) => {
          let color1 = data.mainSkillValue > 6 ? 'var(--contrast-4)' : '#898989';
          let color2 = data.mainSkillValue > 7 ? 'var(--contrast-4)' : '#898989';
          let background = 'linear-gradient(90deg, ' + color1 + ' 50%, ' + color2 + ' 50%)';

          return {
            componentType: 'buttonc',
            tooltip: "",
            type: 'button icon-overlay square',
            icon: 'fa-star',
            disabled: false,
            styleButton: {margin: '0px', padding: '0px'},
            styleIcon: {
              backgroundImage: background,
              backgroundClip: 'text',
              '-webkit-background-clip': 'text',
              color: 'transparent'
            },
            customEvents: {
              click: (event) => {
                let employeeSkill = {
                  id: data.mainSkillId,
                  employeeId: data.id
                }
                if (event.offsetX < 10) {
                  employeeSkill.value = 7;
                } else {
                  employeeSkill.value = 8;
                }
                view.EditEmployeeSkillBackendCall(employeeSkill);
              }
            }
          }
        },
        (data, entry) => {
          let color1 = data.mainSkillValue > 8 ? 'var(--contrast-4)' : '#898989';
          let color2 = data.mainSkillValue > 9 ? 'var(--contrast-4)' : '#898989';
          let background = 'linear-gradient(90deg, ' + color1 + ' 50%, ' + color2 + ' 50%)';

          return {
            componentType: 'buttonc',
            tooltip: "",
            type: 'button icon-overlay square',
            icon: 'fa-star',
            disabled: false,
            styleButton: {margin: '0px', padding: '0px'},
            styleIcon: {
              backgroundImage: background,
              backgroundClip: 'text',
              '-webkit-background-clip': 'text',
              color: 'transparent'
            },
            customEvents: {
              click: (event) => {
                let employeeSkill = {
                  id: data.mainSkillId,
                  employeeId: data.id
                }
                if (event.offsetX < 10) {
                  employeeSkill.value = 9;
                } else {
                  employeeSkill.value = 10;
                }
                view.EditEmployeeSkillBackendCall(employeeSkill);
              }
            }
          }
        }
      ];

    
      state.headerMap.skillCount.stylesEntrySum = {color: 'black'}
        state.headerMap.skillCount.sort = false;
        state.headerMap.skillCount.componentStateBuilders = [(data, entry) => {
        return {
          componentType: 'labelc',
          state: {
            text: this.employeeEmployeeSkillMap[data.id].filter(es => es.skillId != -2).length,
          },
          styleLabel: {
            display: 'flex', alignItems: 'center', justifyContent: 'center', background: '', height: 'calc(100% - 10px)'
          },
        }

      }];

      // Actions
      state.headerMap.actions.stylesEntry = {'justify-content': 'left'};
      if (!this.canEditValues) {
        state.headerMap.actions.componentStateBuilders = [];
      } else {
        state.headerMap.actions.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: 'buttonc',
              tooltip: () => {
                return this.$t('global.ui.createX', [this.$tc('store.structure.skill')])
              },
              disabled: this.hasAllSkills(data),
              type: 'button icon-overlay square',
              icon: 'fa-plus',
              styleButton: {margin: '0 2px 0 2px'},
              customEvents: {
                click: (event) => {
                  view.NewEmployeeSkill(data);
                }
              }
            }
          },
          (data, entry) => {
            return {
              componentType: 'buttonc',
              tooltip: () => {
                return this.$t('global.ui.editX', [this.$tc('store.structure.skill')])
              },
              disabled: this.employeeEmployeeSkillMap[data.id].filter(es => es.skillId == -2).length > 0,
              type: 'button icon-overlay square',
              icon: 'fa-edit',
              styleButton: {margin: '0 2px 0 2px'},
              customEvents: {
                click: (event) => {
                  view.EditEmployeeSkills(data);
                }
              }
            }
          }
        ];
      }

      let entries = Object.entries(state.headerMap);

      let mainColumnWidth = 25;
      let mainColumns = ["mainSkill", "mainSkillValue", "skillCount"];
      let nameColumns = ["name"];
      let nameColumnWidth = this.sortByName ? 15 : 10;

      let persColumns = ["personnelId"];
      let persColumnWidth = 5;
      let actionColumns = ["actions"];
      let actionColumnWidth = 5;
      for (let x in entries) {

        if (mainColumns.includes(entries[x][0])) {
          entries[x][1].width = mainColumnWidth + '%';
        } else if (nameColumns.includes(entries[x][0])) {
          entries[x][1].width = nameColumnWidth + '%';
        } else if (persColumns.includes(entries[x][0])) {
          entries[x][1].width = persColumnWidth + '%';
        } else if (actionColumns.includes(entries[x][0])) {
          entries[x][1].width = actionColumnWidth + '%';
        }
        //entries[x][1].width = ((100 / (entries.length + 1)) * (x === (''+(entries.length-1)) ? 0.5 : 1)) + '%';
        //console.log(entries[x][1].width)
        entries[x][1].key = entries[x][0];

      }
      state.headerStyles = {position: "sticky", top: 0, zIndex: 10, background: 'var(--sub-menu)'};
      state.heightSubRow = 'fit-content';
      state.rowStyles = {background: '#6d8d23'};
      state.rowStylesCollapsed = {background: 'var(--contrast-1)'};
      state.sumRowStyles = {background: 'var(--sub-menu)'}
      state.alwaysUnfold = this.alwaysUnfold;
      return state;
    },
  },
  watch: {
    rosterFromTo(newVal, oldVal) {
      if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
        console.log("CALLING REFRESH FROM ROSTERFROMTO")
        this.refresh(true);
      }
    },
    storeId(newVal, oldVal) {
      if (newVal != oldVal) {
        console.log("Changed storeId: " + newVal);
        console.log("CALLING REFRESH FROM STOREID")
        this.refresh(true);
        this.readyFlag = false;
      }
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {

      if (!this.loading) {
        let view = this;
        this.loading = true;
        return view.$helpers.GetEmployeeSkillMap(force)
            .then(response => {
              return view.$helpers.GetSkillMap(force);
            }).then(response => {
              return view.$helpers.GetSpotMap(force);
            }).then(response => {
              view.LoadSkillsDropdown();
              return view.loadEmployees()
            }).then(response => {
              view.updateEmployees(response.data);
              let employeePayload = {
                ids: []
              };
              for (let i = 0; i < response.data.length; i++) {
                employeePayload.ids.push(response.data[i].id);
              }

              view.loading = false;
            }).catch(function (error) {
              view.loading = false;
              console.log(error)
            });
      }
    },

    hasAllSkills(employee) {
      if (Object.values(this.employeeSkillMap).filter(empSkill => empSkill.employeeId === employee.id).length >= Object.values(this.skillMap).length) {
        return true;
      }
      return false;
    },

    
    OpenSkillsDropdown($event) {
      var view = this;
      let target;
      if ($event != undefined) target = $event.currentTarget;


      this.$helpers.OpenPopup({
        elRelative: target,
        type: 'list',
        componentState: {
          entries: view.skillsDropdownOptions,
        },
        remainAfterSelect: true,
        pointerDirection: -1,
        iconsLeft: true,
        selectCallback: function ($event, item, dropdown) {
          item.toggled = !item.toggled;

          if (item.all) {
            view.skillsDropdownOptions.forEach(option => {
              option.toggled = item.toggled;
            })
          }
          view.skillsDropdownOptions = view.skillsDropdownOptions.slice();
        },
      });
    },
    LoadSkillsDropdown() {
      let view = this;
      let skillsDropdownOptions = [];
      Object.values(view.skillMap).forEach(function (skill) {
        let found = false;
        Object.values(view.spotMap).forEach(function (spot) {
          if (spot.requiredSkill === skill.id) {
            let option = {label: skill.name, toggled: true, color: spot.color, id: skill.id};
            skillsDropdownOptions.push(option);
            found = true;
          }
        });
        if (!found) {
          let option = {label: skill.name, toggled: true, color: "#eeeeee", id: skill.id};
          skillsDropdownOptions.push(option);
        }
      });
      skillsDropdownOptions.push({
        label: this.$t('pages.comp.noSkill'),
        toggled: true,
        color: "#eeeeee",
        id: -2
      });
      skillsDropdownOptions.push({
        label: this.$t('global.ui.all'),
        toggled: true,
        all: true,
        color: "#eeeeee",
        id: -1
      });
      this.skillsDropdownOptions = skillsDropdownOptions;
    },

    OpenMenuDetails($event, state) {
      let view = this;

      this.$helpers.OpenPopup({
        type: 'burgermenu',
        componentState: state,
        listStyle: true,
        noScroll: true,
        pointerDirection: 0,
        elRelative: $event.currentTarget,
        pointerOffset: -15,
      });
    },
    loadEmployees: function () {
      let url = '/api/sec/employee';
      let params = {
        storeId: this.$store.state.storeId,
      };


      return this.axios({
        method: 'get',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url
      })

    },
    updateEmployees: function (data) {

      let employeeMap = {}

      for (let i = 0; i < data.length; i++) {
        employeeMap[data[i].id] = data[i];
      }

      this.employeeMap = employeeMap;
    },

    NewEmployeeSkill(employeeT) {
      let view = this;
      let employee = Object.assign({}, employeeT);

      this.PopupNewEmployeeSkill({currentTarget: null}, employee, (employeeSkill) => {
        view.NewEmployeeSkillBackendCall(employeeSkill);
      });
    },
    EditEmployeeSkills(employeeT) {
      let view = this;
      let employee = Object.assign({}, employeeT);

      this.PopupEditEmployeeSkills(
          {currentTarget: null},
          employee,
          (employeeSkill) => {
            view.EditEmployeeSkillBackendCall(employeeSkill);
          },
          (employeeSkill) => {
            if (employeeSkill.id === employee.mainSkillId) {
              view.$helpers.error(view.$t('global.notifications.error'), this.$t('pages.comp.deleteSkillPositionError'));
            } else {
              view.DeleteEmployeeSkillBackendCall(employeeSkill);
            }
          }
      );
    },

    PopupNewEmployeeSkill($event, employee, createCallback) {
      let view = this;

      let employeeSkillMap = Object.values(view.employeeSkillMap)
          .filter(empSkill => employee.id === empSkill.employeeId)
          .map(e => {
            return Object.assign({}, e);
          });

      let missingEmployeeSkills = [];
      Object.values(view.skillMap).forEach(skill => {
        if (!employeeSkillMap.some(empSkill => empSkill.skillId === skill.id)) {
          missingEmployeeSkills.push({label: skill.name, value: skill.id})
        }
      });
      missingEmployeeSkills = missingEmployeeSkills.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });

      let dataEntries = [
        {
          label: 'EmployeeId',
          key: 'employeeId',
          hidden: true,
          type: 'text',
          value: employee.id,
          length: 20
        },
        {
          label: this.$t('pages.employeeData.name'),
          key: 'name',
          hidden: false,
          type: 'text',
          length: 50,
          disabled: true,
          value: this.anonMode ? this.$t('roster.view.anonymousEmployee') : employee.lastName + ' ' + employee.firstName
        },
        {
          label: this.$tc('store.structure.skill'),
          key: 'skillId',
          hidden: false,
          type: 'dropdownsearch',
          selectMultiple: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: missingEmployeeSkills,
            selectMultiple: false,
            selectFirst: true,
            styleLight: true,
          }
        },
        {
          label: this.$t('workBalance.extraPay.value'),
          key: 'value',
          hidden: false,
          type: 'slider',
          slider: {min: 1, max: 10, value: 1, inputControl: true, sliderInput: (x) => {return x}},
          value: 1
        },
      ];
      let target = $event.currentTarget;

      this.$helpers.OpenPopup({
        elRelative: target,
        type: 'datafill',
        componentState: {
          entries: dataEntries,
          selectCallback: createCallback
        },
        header: this.$t('pages.comp.newEmpSkill'),
        expanded: true,
        centered: true
      });
    },
    PopupEditEmployeeSkills($event, employee, editCallback, deleteCallback) {
      let view = this;

      let employeeSkillMap = Object.values(view.employeeSkillMap)
          .filter(empSkill => employee.id === empSkill.employeeId)
          .map(e => {
            return Object.assign({}, e);
          });
      employeeSkillMap.sort((a, b) => a.value > b.value);
      let employeeSkills = [];
      let mainSkill = {label: employee.mainSkill, value: employee.mainSkillId};
      employeeSkillMap.forEach(empSkill => {
        employeeSkills.push({label: view.skillMap[empSkill.skillId].name, value: empSkill.id})
      });

      let dataEntries = [
        {
          label: 'EmployeeId',
          key: 'employeeId',
          hidden: true,
          type: 'text',
          value: employee.id,
          length: 20
        },
        {
          label: this.$t('pages.employeeData.name'),
          key: 'name',
          hidden: false,
          type: 'text',
          length: 50,
          disabled: true,
          value: this.anonMode ? this.$t('roster.view.anonymousEmployee') : employee.lastName + ' ' + employee.firstName
        },
        {
          label: this.$tc('store.structure.skill'),
          key: 'id',
          hidden: false,
          type: 'dropdownsearch',
          selectMultiple: false,
          value: mainSkill.value,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: employeeSkills,
            selectMultiple: false,
            selectedItem: mainSkill,
            styleLight: true,
          }
        },
        {
          label: this.$t('workBalance.extraPay.value'),
          key: 'value',
          hidden: false,
          type: 'slider',
          currentSkillId: mainSkill.value,
          computed: function (view2, lastVal, entryBeforeUpdate) {
            let employeeSkillId = view2.entries.find(e => e.key === 'id').value;
            let skill = employeeSkillId === entryBeforeUpdate.currentSkillId ? lastVal : view.employeeSkillMap[employeeSkillId].value;

            return {
              label: this.$t('workBalance.extraPay.value'),
              key: 'value',
              hidden: false,
              type: 'slider',
              currentSkillId: employeeSkillId,
              slider: {min: 1, max: 10, value: skill, inputControl: true, sliderInput: (x) => {return x}},
              value: skill
            }
          },
          slider: {min: 1, max: 10, value: view.employeeSkillMap[mainSkill.value].value, inputControl: true, sliderInput: (x) => {return x}},
          value: view.employeeSkillMap[mainSkill.value].value
        },
      ];


      let target = $event.currentTarget;

      this.$helpers.OpenPopup({
        elRelative: target,
        type: 'datafill',
        componentState: {
          entries: dataEntries,
          selectCallback: editCallback,
          deleteCallback: deleteCallback
        },
        header: this.$t('global.ui.editX', [this.$t('roster.main.employeeSkills')]),
        expanded: true,
        centered: true
      });
    },

    NewEmployeeSkillBackendCall(employeeSkill) {
      let view = this;
      let url = '/api/sec/employeeskill';

      let params = {
        storeId: this.$store.state.storeId
      };

      let payload = {
        employeeId: employeeSkill.employeeId,
        skillId: employeeSkill.skillId,
        value: employeeSkill.value
      };

      this.axios({
        method: 'post',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).then(response => {
        view.$set(view.employeeSkillMap, response.data.data.id, response.data.data);
        view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('global.ui.createdX', [view.$t('pages.comp.empSkill')]))
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createFailed'));
        console.log(error)
      })

    },
    EditEmployeeSkillBackendCall(employeeSkill) {
      let view = this;
      let url = '/api/sec/employeeskill';

      let params = {
        storeId: this.$store.state.storeId
      };

      let payload = {
        id: employeeSkill.id,
        employeeId: employeeSkill.employeeId,
        skillId: view.employeeSkillMap[employeeSkill.id].skillId,
        value: employeeSkill.value,
        updateFields: ["value"]
      };

      this.axios({
        method: 'put',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).then(response => {
        view.$set(view.employeeSkillMap, payload.id, payload);
        view.$helpers.success(view.$t('global.notifications.success'), '');
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.updateFailed'));
        console.log(error)
      })

    },
    DeleteEmployeeSkillBackendCall(employeeSkill) {
      let view = this;
      let url = '/api/sec/employeeskill';

      let params = {
        id: employeeSkill.id,
        storeId: this.$store.state.storeId
      }


      this.axios({
        method: 'delete',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url
      }).then(response => {
        view.$delete(view.employeeSkillMap, employeeSkill.id);
        view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.ui.deletedX', [view.$t('pages.comp.empSkill')]))
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
        console.log(error)
      })
    },

    exportCsv() {
      var date = new Date();
      let ts = (date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2(date.getDate()) + this.$helpers.pad2(date.getHours()) + this.$helpers.pad2(date.getMinutes()) + this.$helpers.pad2(date.getSeconds()));

      let view = this;
      let csvPre = "data:text/csv;charset=utf-8,";
      let csv = "";
      let headers = [this.$t('pages.employeeData.name'), this.$tc('shift.main.position'), this.$tc('store.structure.skill'), this.$t('pages.comp.skillAssessment')];
      if (!view.sortByName) {
        headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$t('pages.employeeData.name'), this.$tc('shift.main.position'), this.$tc('store.structure.skill'), this.$t('pages.comp.skillAssessment')];
      }
      let filename = this.$t('roster.main.employeeSkills') + '_' + this.storeSettings.name + '_' + ts + '.csv';

      csv += headers.join(";");
      csv += "\n";

      let hmap = view.dataTableSimpleState.headerMap;
      let data = view.dataTableSimpleState.data;

      for (let i = 0; i < data.length; i++) {

        let cur = [
          ((data[i].lastName !== undefined ? data[i].lastName + ' ' : '') + (data[i].firstName !== undefined ? data[i].firstName : '')),
          '1',
          data[i].mainSkill ? data[i].mainSkill : 'keine Position',
          data[i].mainSkill ? data[i].mainSkillValue : ''
        ];
        if (!view.sortByName) cur.unshift(hmap.personnelId != undefined ? data[i].personnelId : '');
        let line = cur.join(";");
        csv += line;
        csv += "\n";

        Object.values(view.employeeSkillMap).forEach(empSkill => {
          if (data[i].spotId && data[i].id === empSkill.employeeId && empSkill.skillId === view.spotMap[data[i].spotId].requiredSkill) {
          } else if (data[i].id === empSkill.employeeId) {
            let secondSkill = view.skillMap[empSkill.skillId].name;
            let secondSkillValue = empSkill.value;

            let cur = [
              ((data[i].lastName !== undefined ? data[i].lastName + ' ' : '') + (data[i].firstName !== undefined ? data[i].firstName : '')),
              '0',
              secondSkill,
              secondSkillValue
            ];
            if (!view.sortByName) cur.unshift(hmap.personnelId != undefined ? data[i].personnelId : '');
            let line = cur.join(";");
            csv += line;
            csv += "\n";
          }
        });

      }

      let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", filename);
      document.body.appendChild(link); // Required for FF

      link.click();
    }
  },

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>
.tablecontainer {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
}

.has-header > .has-header > .scrollbar-container {
  height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
  top: var(--header-height);
}


.data-table {
  top: 10px;
  position: relative;
}

::-webkit-scrollbar {
  display: none;
}
</style>
